import type { QuestionProps } from '../eform.types'
import ScaleQuestion from './ScaleQuestion'
import TextQuestion from './TextQuestion'
import TextareaQuestion from './TextareaQuestion'
import TextareaApproval from './TextareaApproval'
import StarRating from './StarRating'
import RadioOptions from './RadioOptions'
import CheckboxOptions from './CheckboxOptions'
import SignatureField from './SignatureField'
import FileUpload from './FileUpload'
import DateField from './DateField'
import HiddenField from './HiddenField'
import DropdownField from './DropdownField'
import HeightWeightBmi from './HeightWeightBmi'
import NameField from './NameField'
import InstructionBlock from './InstructionBlock'
import ScrollAcceptField from './ScrollAcceptField'
import AddressField from './AddressField'
import ReadOnlyDate from './ReadOnlyDate'
import PaymentField from './PaymentPlaceholder'
import OptInToggles from './OptInToggles'

/**
 * Maps legacy questionType numbers to React components.
 * Types 13 and 20 are navigation controls handled by EFormRenderer directly.
 */
export default function QuestionTypeRenderer(props: QuestionProps) {
  const { question } = props

  switch (question.questionType) {
    case 1:
    case 2:
    case 4:
      return <ScaleQuestion {...props} />
    case 3:
    case 9:
    case 25:
      return <TextareaQuestion {...props} />
    case 5:
      return <StarRating {...props} />
    case 6:
      return <TextareaApproval {...props} />
    case 7:
      return <RadioOptions {...props} />
    case 8:
      return <CheckboxOptions {...props} />
    case 10:
      return <TextQuestion {...props} />
    case 11:
      return <SignatureField {...props} />
    case 12:
      return <FileUpload {...props} />
    case 14:
      return <DateField {...props} />
    case 15:
    case 26:
      return <HiddenField {...props} />
    case 16:
      return <DropdownField {...props} />
    case 17:
      return <HeightWeightBmi {...props} />
    case 18:
      return <NameField {...props} />
    case 19:
    case 23:
      return <InstructionBlock {...props} />
    case 21:
      return <PaymentField {...props} />
    case 22:
      return <AddressField {...props} />
    case 24:
      return <ReadOnlyDate {...props} />
    case 27:
      return <OptInToggles {...props} />
    case 28:
      return <ScrollAcceptField {...props} />
    default:
      return <TextQuestion {...props} />
  }
}

/** Question types that are structural (not data-entry fields) */
export const NAVIGATION_TYPES = new Set([13, 20])

/** Question types that are invisible to the user */
export const HIDDEN_TYPES = new Set([15, 26])

/** Question types that are display-only (no answer expected) */
export const DISPLAY_ONLY_TYPES = new Set([19, 23, 24])
